import React from 'react';
import { Alert } from '@mui/material';

const PlatformCreditControls = ({ creditOverview, children }) => {
  if (creditOverview?.tokenPurchasesRequired === false) {
    return (
      <Alert severity="info">
        This university uses its own AI credentials. Platform AI credits are not charged or required;
        previous invoice records remain available below.
      </Alert>
    );
  }

  return children;
};

export default PlatformCreditControls;
